export const BIZ_TYPES = [
  '1차 금속제품 도매업',
  '1차 금속제품 및 금속광물 도매업',
  '1차 유리제품, 유리섬유 및 광학용 유리 제조업',
  '1차 플라스틱제품 제조업',
  '가공 공작기계 제조업',
  '가공 및 정제염 제조업',
  '가공식품 도매업',
  '가구 내 고용활동',
  '가구 소매업',
  '가금류 가공 및 저장 처리업',
  '가금류 도축업',
  '가금류 및 조류 사육업',
  '가발 및 유사 제품 제조업',
  '가발, 장식용품 및 전시용 모형 제조업',
  '가방 및 기타 가죽제품 소매업',
  '가방 및 기타 보호용 케이스 제조업',
  '가방 및 보호용 케이스 도매업',
  '가방, 시계, 안경 및 기타 생활용품 도매업',
  '가전제품 및 부품 도매업',
  '가전제품 소매업',
  '가전제품 수리업',
  '가전제품, 통신장비 및 부품 도매업',
  '가정용 가스 연료 소매업',
  '가정용 고체 연료 소매업',
  '가정용 및 장식용 도자기 제조업',
  '가정용 비전기식 조리 및 난방 기구 제조업',
  '가정용 세탁업',
  '가정용 액체 연료 소매업',
  '가정용 연료 소매업',
  '가정용 유리제품 제조업',
  '가정용 전기 기기 제조업',
  '가정용 전기 난방기기 제조업',
  '가정용 직물제품 소매업',
  '가죽 및 모피 의복 소매업',
  '가죽 및 모피 제품 도매업',
  '가죽, 가방 및 신발 수리업',
  '가죽의복 제조업',
  '간이 음식 포장 판매 전문점',
  '간판 및 광고물 제조업',
  '감광 재료 및 관련 화학제품 제조업',
  '강 주물 주조업',
  '강관 가공품 및 관 연결구류 제조업',
  '강관 제조업',
  '강선 건조업',
  '강화 및 재생 목재 제조업',
  '개발 금융기관',
  '개별 화물 자동차 운송업',
  '개인 간병 및 유사 서비스업',
  '개인 공제업',
  '건강 기능식품 제조업',
  '건강 보조식품 소매업',
  '건강 보조용 액화식품 제조업',
  '건강보험업',
  '건물 및 구축물 해체 공사업',
  '건물 및 산업설비 청소업',
  '건물 및 토목 엔지니어링 서비스업',
  '건물설비 설치 공사업',
  '건물용 금속 공작물 설치 공사업',
  '건물용 기계ㆍ장비 설치 공사업',
  '건반 악기 제조업',
  '건설 및 광업용 기계장비 제조업',
  '건설 및 운송 행정',
  '건설 및 채광용 기계장비 제조업',
  '건설 및 토목공사용 기계ㆍ장비 임대업',
  '건설 폐기물 수집, 운반업',
  '건설 폐기물 처리업',
  '건설ㆍ광업용 기계 및 장비 도매업',
  '건설ㆍ광업용 기계 및 장비 수리업',
  '건설용 석재 채굴 및 쇄석 생산업',
  '건설용 석제품 제조업',
  '건설장비 운영업',
  '건어물 및 젓갈류 도매업',
  '건어물 및 젓갈류 소매업',
  '건축 및 조경 설계 서비스업',
  '건축 설계 및 관련 서비스업',
  '건축물 일반 청소업',
  '건축용 나무제품 제조업',
  '건축용 비내화 요업제품 제조업',
  '건축용 플라스틱제품 제조업',
  '검찰',
  '겉옷 제조업',
  '게임 소프트웨어 개발 및 공급업',
  '게임용구, 인형 및 장난감 소매업',
  '결혼 상담 및 준비 서비스업',
  '경 인쇄업',
  '경기장 운영업',
  '경비 및 경호 서비스업',
  '경성 인쇄회로기판 제조업',
  '경영 컨설팅 및 공공 관계 서비스업',
  '경영 컨설팅업',
  '경제 및 경영학 연구개발업',
  '경주장 및 동물 경기장 운영업',
  '경찰',
  '계면활성제 제조업',
  '계약배달 판매업',
  '고등 교육기관',
  '고무 의류 및 기타 위생용 비경화 고무제품 제조업',
  '고무 타이어 및 튜브 생산업',
  '고무 패킹류 제조업',
  '고무, 화학섬유 및 플라스틱 성형기 제조업',
  '고용 알선업',
  '고체 연료 및 관련제품 도매업',
  '곡물 가공품 제조업',
  '곡물 도정업',
  '곡물 및 기타 식량작물 재배업',
  '곡물 및 유지작물 도매업',
  '곡물 제분업',
  '곡물 혼합 분말 및 반죽 제조업',
  '곡물, 곡분 및 가축 사료 소매업',
  '골재, 벽돌 및 시멘트 도매업',
  '골판지 및 골판지 가공제품 제조업',
  '골판지 상자 및 가공제품 제조업',
  '골판지 제조업',
  '골프 연습장 운영업',
  '골프장 및 스키장 운영업',
  '골프장 운영업',
  '공공관계 서비스업',
  '공구 소매업',
  '공기 조화장치 제조업',
  '공업 특성화 고등학교',
  '공연 기획업',
  '공연 및 제작관련 대리업',
  '공연 예술가',
  '공연단체',
  '공연시설 운영업',
  '공영 우편업',
  '공인회계사업',
  '공작용 기계 및 장비 도매업',
  '공중 보건 의료업',
  '공학 연구개발업',
  '공항 운영업',
  '과실 및 그 외 채소 절임식품 제조업',
  '과실, 음료용 및 향신용 작물 재배업',
  '과실, 채소 가공 및 저장 처리업',
  '과실류 도매업',
  '과실작물 재배업',
  '과자류 및 코코아 제품 제조업',
  '광고 대행업',
  '광고 매체 판매업',
  '광고 영화 및 비디오물 제작업',
  '광고물 문안, 도안, 설계 등 작성업',
  '광물 처리 및 취급장비 제조업',
  '광섬유 케이블 제조업',
  '광업 지원 서비스업',
  '광학 렌즈 및 광학 요소 제조업',
  '교과서 및 학습 서적 출판업',
  '교도기관',
  '교량, 터널 및 철도 건설업',
  '교육 지원 서비스업',
  '교육 행정',
  '교육관련 자문 및 평가업',
  '교통 신호장치 제조업',
  '구두류 제조업',
  '구름베어링 제조업',
  '구조용 금속 판제품 및 공작물 제조업',
  '구조용 금속제품 제조업',
  '국내은행',
  '국방 행정',
  '국제 및 외국기관',
  '귀금속 및 관련제품 제조업',
  '그 외 금속 압형제품 제조업',
  '그 외 금속 파스너 및 나사제품 제조업',
  '그 외 기타 1차 철강 제조업',
  '그 외 기타 가구 제조업',
  '그 외 기타 가정용품 소매업',
  '그 외 기타 개인 및 가정용품 수리업',
  '그 외 기타 개인 및 가정용품 임대업',
  '그 외 기타 거주 복지시설 운영업',
  '그 외 기타 건축 마무리 공사업',
  '그 외 기타 건축자재 도매업',
  '그 외 기타 고무제품 제조업',
  '그 외 기타 광고 관련 서비스업',
  '그 외 기타 교육기관',
  '그 외 기타 금속 가공업',
  '그 외 기타 금속 가공제품 제조업',
  '그 외 기타 금융 지원 서비스업',
  '그 외 기타 금융업',
  '그 외 기타 기계 및 장비 도매업',
  '그 외 기타 나무제품 제조업',
  '그 외 기타 달리 분류되지 않은 개인 서비스업',
  '그 외 기타 달리 분류되지 않은 운송장비 제조업',
  '그 외 기타 달리 분류되지 않은 제품 제조업',
  '그 외 기타 무점포 소매업',
  '그 외 기타 보건업',
  '그 외 기타 봉제의복 제조업',
  '그 외 기타 분류 안된 가정용품 소매업',
  '그 외 기타 분류 안된 개인 서비스업',
  '그 외 기타 분류 안된 교육기관',
  '그 외 기타 분류 안된 금속 가공제품 제조업',
  '그 외 기타 분류 안된 금융업',
  '그 외 기타 분류 안된 비금속 광물제품 제조업',
  '그 외 기타 분류 안된 사업 지원 서비스업',
  '그 외 기타 분류 안된 상품 전문 소매업',
  '그 외 기타 분류 안된 섬유제품 제조업',
  '그 외 기타 분류 안된 오락관련 서비스업',
  '그 외 기타 분류 안된 운송관련 서비스업',
  '그 외 기타 분류 안된 운송장비 제조업',
  '그 외 기타 분류 안된 전문, 과학 및 기술 서비스업',
  '그 외 기타 분류 안된 제품 제조업',
  '그 외 기타 분류 안된 화학제품 제조업',
  '그 외 기타 비거주 복지 서비스업',
  '그 외 기타 비금속 광물제품 제조업',
  '그 외 기타 비금속광물 광업',
  '그 외 기타 사업 지원 서비스업',
  '그 외 기타 상품 전문 도매업',
  '그 외 기타 상품 전문 소매업',
  '그 외 기타 생활용품 도매업',
  '그 외 기타 섬유제품 제조업',
  '그 외 기타 숙박업',
  '그 외 기타 스포츠 서비스업',
  '그 외 기타 스포츠시설 운영업',
  '그 외 기타 식료품 제조업',
  '그 외 기타 여신 금융업',
  '그 외 기타 오락관련 서비스업',
  '그 외 기타 운송관련 서비스업',
  '그 외 기타 유리제품 제조업',
  '그 외 기타 의료용 기기 제조업',
  '그 외 기타 의복 액세서리 제조업',
  '그 외 기타 일반 목적용 기계 제조업',
  '그 외 기타 전기 통신업',
  '그 외 기타 전기장비 제조업',
  '그 외 기타 전문, 과학 및 기술 서비스업',
  '그 외 기타 전자 부품 제조업',
  '그 외 기타 정보 서비스업',
  '그 외 기타 종이 및 판지 제품 제조업',
  '그 외 기타 종합 소매업',
  '그 외 기타 창작 및 예술관련 서비스업',
  '그 외 기타 축산업',
  '그 외 기타 콘크리트 제품 및 유사 제품 제조업',
  '그 외 기타 특수 목적용 기계 제조업',
  '그 외 기타 특정 상품 중개업',
  '그 외 기타 플라스틱 제품 제조업',
  '그 외 기타 협회 및 단체',
  '그 외 기타 화학제품 제조업',
  '그 외 자동차용 신품 부품 제조업',
  '근무복, 작업복 및 유사 의복 제조업',
  '금속 가구 제조업',
  '금속 단조, 압형 및 분말 야금제품 제조업',
  '금속 단조제품 제조업',
  '금속 문, 창, 셔터 및 관련제품 제조업',
  '금속 성형기계 제조업',
  '금속 스프링 제조업',
  '금속 열처리, 도금 및 기타 금속 가공업',
  '금속 열처리업',
  '금속 위생용품 제조업',
  '금속 절삭기계 제조업',
  '금속 주조 및 기타 야금용 기계 제조업',
  '금속 캔 및 기타 포장용기 제조업',
  '금속 탱크 및 저장 용기 제조업',
  '금속 파스너, 스프링 및 금속선 가공제품 제조업',
  '금속 표시판 제조업',
  '금속광물 도매업',
  '금속류 원료 재생업',
  '금속류 해체 및 선별업',
  '금속류 해체, 선별 및 원료 재생업',
  '금속선 가공제품 제조업',
  '금융 리스업',
  '금융시장 관리업',
  '기계 및 장비 중개업',
  '기계장비 조립용 플라스틱제품 제조업',
  '기관 구내식당업',
  '기관차 및 기타 철도 차량 제조업',
  '기금 운영업',
  '기기용 자동 측정 및 제어장치 제조업',
  '기념품, 관광 민예품 및 장식용품 소매업',
  '기독교 단체',
  '기록매체 복제업',
  '기반조성 관련 전문공사업',
  '기숙사 및 고시원 운영업',
  '기술 및 직업 훈련학원',
  '기술 시험, 검사 및 분석업',
  '기어 및 동력전달장치 제조업',
  '기억 장치 및 주변 기기 제조업',
  '기억 장치 제조업',
  '기원 운영업',
  '기체 여과기 제조업',
  '기체 연료 및 관련제품 도매업',
  '기체 펌프 및 압축기 제조업',
  '기초 무기화학 물질 제조업',
  '기초 유기화학 물질 제조업',
  '기초 의약 물질 및 생물학적 제제 제조업',
  '기타 1차 비철금속 제조업',
  '기타 1차 철강 제조업',
  '기타 가공 공작기계 제조업',
  '기타 가공식품 도매업',
  '기타 가구 제조업',
  '기타 가금류 및 조류 사육업',
  '기타 가정용 전기 기기 제조업',
  '기타 가죽제품 제조업',
  '기타 간이 음식점업',
  '기타 개인 및 가정용품 수리업',
  '기타 개인 및 가정용품 임대업',
  '기타 거주 복지시설 운영업',
  '기타 건물 관련설비 설치 공사업',
  '기타 건축 마무리 공사업',
  '기타 건축용 나무제품 제조업',
  '기타 건축용 비내화 요업제품 제조업',
  '기타 건축용 플라스틱 조립제품 제조업',
  '기타 건축자재 도매업',
  '기타 게임 소프트웨어 개발 및 공급업',
  '기타 고무제품 제조업',
  '기타 곡물 가공품 제조업',
  '기타 공동 주택 건설업',
  '기타 공연단체',
  '기타 공학 연구개발업',
  '기타 과실ㆍ채소 가공 및 저장 처리업',
  '기타 광고업',
  '기타 광학 기기 제조업',
  '기타 광학 및 정밀 기기 소매업',
  '기타 교습학원',
  '기타 교육지원 서비스업',
  '기타 구조용 금속제품 제조업',
  '기타 국제 및 외국기관',
  '기타 금융 지원 서비스업',
  '기타 금융 투자업',
  '기타 기계 및 장비 도매업',
  '기타 기계ㆍ장비 조립용 플라스틱제품 제조업',
  '기타 기관 및 터빈 제조업',
  '기타 기반조성 관련 전문공사업',
  '기타 기술 및 직업 훈련학원',
  '기타 기술 시험, 검사 및 분석업',
  '기타 기초 무기화학 물질 제조업',
  '기타 나무제품 제조업',
  '기타 내륙 수상 운송업',
  '기타 대형 종합 소매업',
  '기타 도로 화물 운송업',
  '기타 도시 정기 육상 여객 운송업',
  '기타 목재 가구 제조업',
  '기타 무선 통신장비 제조업',
  '기타 무점포 소매업',
  '기타 물품 취급장비 제조업',
  '기타 미용업',
  '기타 반도체 소자 제조업',
  '기타 발전업',
  '기타 발효주 제조업',
  '기타 방적업',
  '기타 법무관련 서비스업',
  '기타 보건업',
  '기타 보관 및 창고업',
  '기타 보험 및 연금관련 서비스업',
  '기타 봉제의복 제조업',
  '기타 부동산 개발 및 공급업',
  '기타 부동산 임대업',
  '기타 부정기 여객 육상 운송업',
  '기타 비거주 복지 서비스업',
  '기타 비알코올 음료 제조업',
  '기타 비알코올 음료점업',
  '기타 비전기식 생활용 기기 및 기구 도매업',
  '기타 비주거용 건물 건설업',
  '기타 비철금속 압연, 압출 및 연신제품 제조업',
  '기타 비철금속 제련, 정련 및 합금 제조업',
  '기타 비철금속 주조업',
  '기타 사무 지원 서비스업',
  '기타 사법 및 공공 질서 행정',
  '기타 사행시설 관리 및 운영업',
  '기타 사회서비스 관리 행정',
  '기타 산업 진흥 행정',
  '기타 산업 회사본부',
  '기타 산업용 기계 및 장비 도매업',
  '기타 산업용 기계 및 장비 임대업',
  '기타 산업용 농산물 도매업',
  '기타 산업용 유리제품 제조업',
  '기타 생활용 섬유 및 직물 제품 도매업',
  '기타 석유 정제물 재처리업',
  '기타 석제품 제조업',
  '기타 선박 건조업',
  '기타 섬유, 의복 및 가죽 가공기계 제조업',
  '기타 수산동물 가공 및 저장 처리업',
  '기타 수상 운송 지원 서비스업',
  '기타 수상오락 서비스업',
  '기타 숙박업',
  '기타 스포츠 교육기관',
  '기타 스포츠 서비스업',
  '기타 스포츠시설 운영업',
  '기타 시민운동 단체',
  '기타 시설작물 재배업',
  '기타 식료품 소매업',
  '기타 식료품 제조업',
  '기타 식사용 가공처리 조리식품 제조업',
  '기타 식품 첨가물 제조업',
  '기타 신발 제조업',
  '기타 신선 식품 및 단순 가공 식품 도매업',
  '기타 악기 제조업',
  '기타 엔지니어링 서비스업',
  '기타 여행 보조 및 예약 서비스업',
  '기타 예술학원',
  '기타 오락용품 제조업',
  '기타 오락장 운영업',
  '기타 옥외 시설물 축조관련 전문공사업',
  '기타 외국식 음식점업',
  '기타 운동 및 경기용구 제조업',
  '기타 운송장비 임대업',
  '기타 유리제품 제조업',
  '기타 유사 여가관련 서비스업',
  '기타 육상 운송지원 서비스업',
  '기타 음ㆍ식료품 위주 종합 소매업',
  '기타 음향기기 제조업',
  '기타 의료용 기기 제조업',
  '기타 의복 소매업',
  '기타 의복 액세서리 제조업',
  '기타 인문 및 사회과학 연구개발업',
  '기타 인쇄관련 산업',
  '기타 인쇄물 출판업',
  '기타 인쇄업',
  '기타 일반 공공 행정',
  '기타 일반 기계 및 장비 수리업',
  '기타 일반 도자기 제조업',
  '기타 일반 목적용 기계 제조업',
  '기타 일반 및 생활 숙박시설 운영업',
  '기타 자동차 신품 부품 및 내장품 판매업',
  '기타 자연과학 연구개발업',
  '기타 작물 재배업',
  '기타 전기 변환장치 제조업',
  '기타 전기 통신업',
  '기타 전기장비 제조업',
  '기타 전문 서비스업',
  '기타 전자 부품 제조업',
  '기타 절연선 및 케이블 제조업',
  '기타 정보 기술 및 컴퓨터 운영 관련 서비스업',
  '기타 제철 및 제강업',
  '기타 조명장치 제조업',
  '기타 종교 단체',
  '기타 종이 및 판지 제조업',
  '기타 종이 및 판지 제품 제조업',
  '기타 종이 상자 및 용기 제조업',
  '기타 주변 기기 제조업',
  '기타 주점업',
  '기타 중고 상품 소매업',
  '기타 증류주 및 합성주 제조업',
  '기타 직물제품 제조업',
  '기타 창작 및 예술관련 서비스업',
  '기타 축산업',
  '기타 측정, 시험, 항해, 제어 및 정밀 기기 제조업',
  '기타 토목 시설물 건설업',
  '기타 통신 판매업',
  '기타 특성화 고등학교',
  '기타 특수 목적용 기계 제조업',
  '기타 판유리 가공품 제조업',
  '기타 편조 의복 액세서리 제조업',
  '기타 표시장치 제조업',
  '기타 플라스틱 발포 성형제품 제조업',
  '기타 플라스틱 제품 제조업',
  '기타 항공 운송지원 서비스업',
  '기타 해상 운송업',
  '기타 화학 물질 및 화학제품 도매업',
  '기타 환경 정화 및 복원업',
  '기타 회계 관련 서비스업',
  '김밥 및 기타 간이 음식점업',
  '김치류 제조업',
  '끈 및 로프 제조업',
  '끈, 로프, 망 및 끈 가공품 제조업',
  '낙농제품 및 식용 빙과류 제조업',
  '낙농품 및 동ㆍ식물성 유지 도매업',
  '낚시 및 수렵용구 제조업',
  '낚시장 운영업',
  '날붙이 제조업',
  '날붙이, 수공구 및 일반 철물 제조업',
  '날염 가공업',
  '남녀용 겉옷 및 셔츠 도매업',
  '남자용 겉옷 소매업',
  '남자용 겉옷 제조업',
  '내륙 수상 및 항만 내 운송업',
  '내륙 수상 여객 및 화물 운송업',
  '내부 전기배선 공사업',
  '내부 통신배선 공사업',
  '내수면 양식 어업',
  '내수면 어업',
  '내연기관 및 터빈 제조업; 항공기용 및 차량용 제외',
  '내연기관 제조업',
  '내항 여객 운송업',
  '내항 운송업',
  '내항 화물 운송업',
  '내화 요업제품 제조업',
  '냉ㆍ난방장치 및 철물, 수공구 도매업',
  '냉각, 공기 조화, 여과, 증류 및 가스 발생기 제조업',
  '냉간 압연 및 압출 제품 제조업',
  '냉장 및 냉동 창고업',
  '노동 및 산업 진흥 행정',
  '노동 행정',
  '노동조합',
  '노래 연습장 운영업',
  '노인 거주 복지시설 운영업',
  '노인 양로 복지시설 운영업',
  '노인 요양 복지시설 운영업',
  '노점 및 유사 이동 소매업',
  '녹음시설 운영업',
  '놀이터용 장비 제조업',
  '농림수산 행정',
  '농림수산학 및 수의학 연구개발업',
  '농림업용 기계 및 장비 도매업',
  '농산물 건조, 선별 및 기타 수확 후 서비스업',
  '농산물 창고업',
  '농업 및 임업용 기계 제조업',
  '뉴스 제공업',
  '늘찬 배달업',
  '다이오드, 트랜지스터 및 유사 반도체 소자 제조업',
  '단독 주택 건설업',
  '단미사료 및 기타 사료 제조업',
  '단추 및 유사 파스너 제조업',
  '담배 도매업',
  '담배 소매업',
  '담배 제조업',
  '담배제품 제조업',
  '당구장 운영업',
  '대안학교',
  '대학교',
  '대학원',
  '대형 마트',
  '대형 종합 소매업',
  '데이터베이스 및 온라인 정보 제공업',
  '도금, 착색 및 기타 표면 처리 강재 제조업',
  '도금업',
  '도로 건설업',
  '도로 및 관련시설 운영업',
  '도로 화물 운송업',
  '도료 도매업',
  '도배, 실내 장식 및 내장 목공사업',
  '도서관 및 기록 보존소 운영업',
  '도서관, 기록 보존소 및 독서실 운영업',
  '도시 계획 및 조경 설계 서비스업',
  '도시 정기 육상 여객 운송업',
  '도시락 및 식사용 조리식품 제조업',
  '도시락류 제조업',
  '도시철도 운송업',
  '도장 공사업',
  '도장 및 기타 피막 처리업',
  '도장, 도배 및 내장 공사업',
  '도축업',
  '독서실 운영업',
  '동 압연, 압출 및 연신제품 제조업',
  '동 제련, 정련 및 합금 제조업',
  '동 주물 주조업',
  '동력식 수지 공구 제조업',
  '동물성 및 식물성 유지 제조업',
  '동물성 유지 제조업',
  '동물용 사료 및 조제식품 제조업',
  '동물용 의약품 제조업',
  '두발 미용업',
  '두부 및 유사 식품 제조업',
  '디스플레이 장치용 유리 제조업',
  '디스플레이 제조용 기계 제조업',
  '디지털 적층 성형기계 제조업',
  '떡, 빵 및 과자류 제조업',
  '떡류 제조업',
  '라디오 방송업',
  '라디오, 녹음 및 재생 기기 제조업',
  '라이터, 연소물 및 흡연용품 제조업',
  '레미콘 제조업',
  '레이더, 항행용 무선 기기 및 측량 기구 제조업',
  '레크리에이션 교육기관',
  '마그네틱 및 광학 매체 제조업',
  '마사지업',
  '만화 출판업',
  '말 및 양 사육업',
  '매니저업',
  '매트리스 및 침대 제조업',
  '맥아 및 맥주 제조업',
  '메모리용 전자집적회로 제조업',
  '면 방적업',
  '면류, 마카로니 및 유사 식품 제조업',
  '면세점',
  '면직물 직조업',
  '모 방적업',
  '모래 및 자갈 채취업',
  '모바일 게임 소프트웨어 개발 및 공급업',
  '모자 제조업',
  '모조 귀금속 및 모조 장신용품 제조업',
  '모직물 직조업',
  '모터사이클 및 부품 도매업',
  '모터사이클 및 부품 소매업',
  '모터사이클 및 부품 판매업',
  '모터사이클 수리업',
  '모터사이클 제조업',
  '모피 및 가죽 제조업',
  '모피제품 제조업',
  '목재 가구 제조업',
  '목재 깔판류 및 기타 적재판 제조업',
  '목재 도구 및 주방용 나무제품 제조업',
  '목재 문 및 관련제품 제조업',
  '목재 및 건축자재 중개업',
  '목재 보존, 방부처리, 도장 및 유사 처리업',
  '목재 상자, 드럼 및 적재판 제조업',
  '목재 포장용 상자, 드럼 및 유사 용기 제조업',
  '무기 및 총포탄 제조업',
  '무기 안료, 염료, 유연제 및 기타 착색제 제조업',
  '무기 안료용 금속 산화물 및 관련 제품 제조업',
  '무도 유흥 주점업',
  '무도장 운영업',
  '무선 및 위성 통신업',
  '무용 및 음악단체',
  '무인 항공기 및 무인 비행장치 제조업',
  '무형 재산권 임대업',
  '문구용 종이제품 제조업',
  '문구용품 및 회화용품 소매업',
  '문구용품, 회화용품, 사무용품 도매업',
  '문서 작성업',
  '문화 및 관광 행정',
  '물류 터미널 운영업',
  '물리, 화학 및 생물학 연구개발업',
  '물질 검사, 측정 및 분석 기구 제조업',
  '물질 성분 검사 및 분석업',
  '물품 감정, 계량 및 견본 추출업',
  '미술학원',
  '미장, 타일 및 방수 공사업',
  '민박업',
  '민족 종교 단체',
  '바이오 연료 및 혼합물 제조업',
  '박물관 및 사적지 관리 운영업',
  '박물관 운영업',
  '박판, 합판 및 강화 목제품 제조업',
  '박판, 합판 및 유사 적층판 제조업',
  '반도체 및 디스플레이 제조용 기계 제조업',
  '반도체 제조용 기계 제조업',
  '발광 다이오드 제조업',
  '발전업',
  '발효주 제조업',
  '방문 교육학원',
  '방문 복지서비스 제공업',
  '방문 판매업',
  '방사선 장치 및 전기식 진단 기기 제조업',
  '방사선 장치 제조업',
  '방사선 진단 및 병리 검사 의원',
  '방사성 폐기물 수집, 운반 및 처리업',
  '방송 및 무선 통신장비 제조업',
  '방송 프로그램 제작업',
  '방송장비 제조업',
  '방음, 방진 및 내화 공사업',
  '방적 및 가공사 제조업',
  '방전 램프용 안정기 제조업',
  '방직용 섬유 및 실 도매업',
  '방직용 섬유, 실 및 직물 도매업',
  '배관 및 냉ㆍ난방 공사업',
  '배관 및 냉ㆍ난방장치 도매업',
  '배전반 및 전기 자동제어반 제조업',
  '배합 사료 제조업',
  '백화점',
  '번역 및 통역 서비스업',
  '벌목업',
  '법무관련 서비스업',
  '법무사업',
  '법원',
  '베어링, 기어 및 동력 전달장치 제조업',
  '벽 및 바닥 피복용 플라스틱 제품 제조업',
  '벽지 및 장판류 도매업',
  '벽지 및 장판지 제조업',
  '벽지, 마루덮개 및 장판류 소매업',
  '변리사업',
  '변압기 제조업',
  '변호사업',
  '병원',
  '보건 및 복지 행정',
  '보관 및 창고업',
  '보링, 그라우팅 및 관정 공사업',
  '보안 시스템 서비스업',
  '보육시설 운영업',
  '보증보험업',
  '보험 대리 및 중개업',
  '보험 및 연금관련 서비스업',
  '복권 발행 및 판매업',
  '복사업',
  '복합비료 및 기타 화학비료 제조업',
  '볼링장 운영업',
  '볼트 및 너트류 제조업',
  '부동산 감정 평가업',
  '부동산 개발 및 공급업',
  '부동산 관리업',
  '부동산 임대업',
  '부동산 중개 및 대리업',
  '부동산 중개, 자문 및 감정 평가업',
  '부동산 투자 자문업',
  '부정기 육상 여객 운송업',
  '부정형 내화 요업제품 제조업',
  '부직포 및 펠트 제조업',
  '분뇨 처리업',
  '분말 야금제품 제조업',
  '분사기 및 소화기 제조업',
  '불교 단체',
  '비 및 솔 제조업',
  '비계 및 형틀 공사업',
  '비공연 예술가',
  '비금속광물 분쇄물 생산업',
  '비금속류 원료 재생업',
  '비금속류 해체 및 선별업',
  '비금속류 해체, 선별 및 원료 재생업',
  '비내화 모르타르 제조업',
  '비내화 일반 도자기 제조업',
  '비누 및 세정제 도매업',
  '비동력식 수공구 제조업',
  '비디오 및 기타 영상 기기 제조업',
  '비디오물 감상실 운영업',
  '비료 및 농약 도매업',
  '비료 및 질소 화합물 제조업',
  '비메모리용 및 기타 전자집적회로 제조업',
  '비알코올 음료 도매업',
  '비알코올 음료 및 얼음 제조업',
  '비알코올 음료점업',
  '비주거용 건물 개발 및 공급업',
  '비주거용 건물 건설업',
  '비주거용 건물 임대업',
  '비주거용 부동산 관리업',
  '비철금속 광업',
  '비철금속 압연, 압출 및 연신제품 제조업',
  '비철금속 제련, 정련 및 합금 제조업',
  '비철금속 주조업',
  '빵류 제조업',
  '빵류, 과자류 및 당류 소매업',
  '빵류, 과자류, 당류, 초콜릿 도매업',
  '사람 분뇨 처리업',
  '사료 도매업',
  '사무 및 회화용품 제조업',
  '사무 지원 서비스업',
  '사무ㆍ상업용 및 공공기관용 건물 건설업',
  '사무용 가구 및 기기 도매업',
  '사무용 기계 및 장비 제조업',
  '사무용 기기 소매업',
  '사무용 기기, 안경, 사진장비 및 정밀기기 소매업',
  '사법 및 공공 질서 행정',
  '사업 공제업',
  '사업 및 무형 재산권 중개업',
  '사업시설 유지ㆍ관리 서비스업',
  '사적지 관리 운영업',
  '사진 처리업',
  '사진 촬영 및 처리업',
  '사진기 및 사진용품 소매업',
  '사진기, 영사기 및 관련 장비 제조업',
  '사진장비 및 광학기기 제조업',
  '사행시설 관리 및 운영업',
  '사회교육시설',
  '사회보장 행정',
  '사회보장보험업',
  '사회복지 상담 서비스 제공업',
  '사회서비스 관리 행정',
  '산업 단체',
  '산업 생산시설 종합 건설업',
  '산업 재해 및 기타 사회보장보험업',
  '산업 처리공정 제어장비 제조업',
  '산업설비, 운송장비 및 공공장소 청소업',
  '산업용 가스 제조업',
  '산업용 그 외 비경화 고무제품 제조업',
  '산업용 기계 및 장비 도매업',
  '산업용 난방 보일러, 금속탱크 및 유사 용기 제조업',
  '산업용 난방보일러 및 방열기 제조업',
  '산업용 냉장 및 냉동장비 제조업',
  '산업용 농ㆍ축산물 및 동ㆍ식물 도매업',
  '산업용 농ㆍ축산물, 섬유 원료 및 동물 중개업',
  '산업용 로봇 제조업',
  '산업용 섬유 세척, 염색, 정리 및 가공 기계 제조업',
  '산업용 세탁업',
  '산업용 송풍기 및 배기장치 제조업',
  '산업용 오븐, 노 및 노용 버너 제조업',
  '산업용 유리 제조업',
  '산업용 트럭 및 적재기 제조업',
  '산업용 트럭, 승강기 및 물품 취급장비 제조업',
  '산업용수 공급업',
  '살균ㆍ살충제 및 농약 제조업',
  '상업 및 정보산업 특성화 고등학교',
  '상업용 사진 촬영업',
  '상용 인력 공급 및 인사관리 서비스업',
  '상품 종합 도매업',
  '상품 종합 중개업',
  '상품 중개업',
  '상호 저축은행 및 기타 저축기관',
  '생맥주 전문점',
  '생명보험업',
  '생물 살균ㆍ살충제 및 식물보호제 제조업',
  '생물학적 제제 제조업',
  '생수 생산업',
  '생활용 가구 도매업',
  '생활용 가구, 조명기구 및 비전기식 생활용기기 도매업',
  '생활용 섬유 및 실 도매업',
  '생활용 섬유제품, 의복, 의복 액세서리 및 모피제품 도매업',
  '생활용 유리ㆍ요업ㆍ목재ㆍ금속 제품 및 날붙이 도매업',
  '생활용 포장 및 위생용품, 봉투 및 유사 제품 도매업',
  '생활용 포장ㆍ위생용품, 문구용품 및 출판 인쇄물 도매업',
  '생활용수 공급업',
  '서양식 음식점업',
  '서적 및 문구용품 소매업',
  '서적 임대업',
  '서적 출판업',
  '서적, 신문 및 잡지류 소매업',
  '서적, 잡지 및 기타 인쇄물 도매업',
  '석유 정제물 재처리업',
  '석유화학계 기초 화학 물질 제조업',
  '석재, 쇄석 및 모래, 자갈 채취업',
  '석제품 제조업',
  '석탄 광업',
  '석탄화학계 화합물 및 기타 기초 유기화학 물질 제조업',
  '석회 및 플라스터 제조업',
  '석회석 및 점토 광업',
  '선물 중개업',
  '선박 구성 부분품 제조업',
  '선박 및 수상 부유 구조물 건조업',
  '선철 주물 주조업',
  '설치용 및 위생용 플라스틱제품 제조업',
  '설탕 제조업',
  '섬유 원단, 실 및 기타 섬유제품 소매업',
  '섬유, 의복 및 가죽 가공기계 제조업',
  '섬유, 의복, 신발 및 가죽제품 중개업',
  '섬유, 직물 및 의복 액세서리 소매업',
  '섬유제품 기타 정리 및 마무리 가공업',
  '섬유제품 염색, 정리 및 마무리 가공업',
  '세무사업',
  '세제, 화장품 및 광택제 제조업',
  '세탁물 공급업',
  '세탁업',
  '세폭직물 제조업',
  '셔츠 및 블라우스 소매업',
  '셔츠 및 블라우스 제조업',
  '소 사육업',
  '소독, 구충 및 방제 서비스업',
  '소방서',
  '소방시설 공사업',
  '소주 제조업',
  '소파 및 기타 내장 가구 제조업',
  '소화물 전문 운송업',
  '속도계 및 적산계기 제조업',
  '속옷 및 잠옷 도매업',
  '속옷 및 잠옷 소매업',
  '속옷 및 잠옷 제조업',
  '손해 및 보증보험업',
  '손해 사정업',
  '손해보험업',
  '솜 및 실 염색 가공업',
  '송전 및 배전업',
  '수동식 식품 가공 기기 및 금속 주방용기 제조업',
  '수력 발전업',
  '수렵 및 관련 서비스업',
  '수산동물 가공 및 저장 처리업',
  '수산동물 건조 및 염장품 제조업',
  '수산동물 냉동품 제조업',
  '수산동물 훈제, 조리 및 유사 조제식품 제조업',
  '수산물 가공식품 도매업',
  '수산물 부화 및 수산 종자 생산업',
  '수산식물 가공 및 저장 처리업',
  '수상 금속 골조 구조재 제조업',
  '수상 운송 지원 서비스업',
  '수상 화물 취급업',
  '수상오락 서비스업',
  '수송용 운송장비 도매업',
  '수영장 운영업',
  '수의업',
  '수중 공사업',
  '수프 및 균질화식품 제조업',
  '슈퍼마켓',
  '스크린 인쇄업',
  '스키장 운영업',
  '스타킹 및 기타양말 제조업',
  '스포츠 및 레크리에이션 교육기관',
  '스포츠 및 레크리에이션 용품 임대업',
  '스포츠 클럽 운영업',
  '승강기 제조업',
  '승용차 및 기타 여객용 자동차 제조업',
  '시각 디자인업',
  '시계 및 귀금속 소매업',
  '시계 및 귀금속 제품 도매업',
  '시계 및 시계 부품 제조업',
  '시계, 귀금속 및 악기 수리업',
  '시내버스 운송업',
  '시멘트 제조업',
  '시멘트, 석회 및 플라스터 제조업',
  '시민운동 단체',
  '시설물 유지관리 공사업',
  '시설물 축조 관련 전문공사업',
  '시설작물 재배업',
  '시스템 소프트웨어 개발 및 공급업',
  '시스템ㆍ응용 소프트웨어 개발 및 공급업',
  '시외버스 운송업',
  '시장 조사 및 여론 조사업',
  '식료품 소매업',
  '식물성 유지 제조업',
  '식물원 및 동물원 운영업',
  '식물원, 동물원 및 자연공원 운영업',
  '식용 정제유 및 가공유 제조업',
  '식초, 발효 및 화학 조미료 제조업',
  '식품 위생용 종이 상자 및 용기 제조업',
  '신문 발행업',
  '신문, 잡지 및 정기 간행물 출판업',
  '신문용지 제조업',
  '신발 도매업',
  '신발 부분품 제조업',
  '신발 소매업',
  '신발 제조업',
  '신선 식품 및 단순 가공 식품 도매업',
  '신선, 냉동 및 기타 수산물 도매업',
  '신선, 냉동 및 기타 수산물 소매업',
  '신용 조사 및 추심 대행업',
  '신용조합',
  '신용조합 및 저축기관',
  '신용카드 및 할부 금융업',
  '신체 부자유자 거주 복지시설 운영업',
  '신탁업 및 집합 투자업',
  '실내 경기장 운영업',
  '실외 경기장 운영업',
  '심신 장애인 거주 복지시설 운영업',
  '아동 및 부녀자 거주 복지시설 운영업',
  '아스팔트 콘크리트 및 혼합제품 제조업',
  '아이스크림 및 기타 식용 빙과류 제조업',
  '아파트 건설업',
  '악기 도매업',
  '악기 소매업',
  '악기 제조업',
  '안경 및 렌즈 소매업',
  '안경 및 안경렌즈 제조업',
  '안경, 사진장비 및 광학용품 도매업',
  '안전유리 제조업',
  '알루미늄 압연, 압출 및 연신제품 제조업',
  '알루미늄 제련, 정련 및 합금 제조업',
  '알루미늄 주물 주조업',
  '암면 및 유사 제품 제조업',
  '압축 및 액화 가스 용기 제조업',
  '애니메이션 영화 및 비디오물 제작업',
  '애완 동물 장묘 및 보호 서비스업',
  '애완용 동물 및 관련용품 소매업',
  '액상 시유 및 기타 낙농제품 제조업',
  '액정 표시장치 제조업',
  '액체 여과기 제조업',
  '액체 연료 및 관련제품 도매업',
  '액체 펌프 제조업',
  '앰뷸런스 서비스업',
  '양계업',
  '양돈업',
  '양식 어업',
  '어망 및 기타 끈 가공품 제조업',
  '어업 관련 서비스업',
  '얼음 제조업',
  '에너지 저장장치 제조업',
  '엔지니어링 서비스업',
  '여객 자동차 터미널 운영업',
  '여관업',
  '여신 금융업',
  '여자용 겉옷 소매업',
  '여자용 겉옷 제조업',
  '여행사업',
  '연 및 아연 제련, 정련 및 합금 제조업',
  '연극단체',
  '연근해 어업',
  '연금 및 공제업',
  '연금업',
  '연료, 광물, 1차 금속, 비료 및 화학제품 중개업',
  '연료, 연료용 광물 및 관련제품 도매업',
  '연료용 가스 제조 및 배관공급업',
  '연마재 제조업',
  '연사 및 가공사 제조업',
  '연성 및 기타 인쇄회로기판 제조업',
  '연탄 및 기타 석탄 가공품 제조업',
  '열간 압연 및 압출제품 제조업',
  '염료, 안료 및 관련제품 도매업',
  '염료, 조제 무기 안료, 유연제 및 기타 착색제 제조업',
  '영림업',
  '영상게임기 제조업',
  '영화 및 비디오물 상영업',
  '영화, 비디오물 및 방송 프로그램 배급업',
  '영화, 비디오물 및 방송 프로그램 제작 관련 서비스업',
  '영화, 비디오물 및 방송 프로그램 제작업',
  '영화관 운영업',
  '예술품 및 골동품 소매업',
  '예술품, 기념품 및 장식용품 소매업',
  '예술학원',
  '예식장업',
  '오디오, 스피커 및 기타 음향 기기 제조업',
  '오디오물 출판 및 원판 녹음업',
  '오락 및 스포츠용 보트 건조업',
  '오락장 운영업',
  '오프셋 인쇄업',
  '옥외 및 전시 광고업',
  '온라인 교육학원',
  '완제 의약품 제조업',
  '외국식 음식점업',
  '외국어학원',
  '외국어학원 및 기타 교습학원',
  '외국은행',
  '외국인학교',
  '외무 행정',
  '외항 여객 운송업',
  '외항 운송업',
  '외항 화물 운송업',
  '요양병원',
  '요업용 도포제 및 관련제품 제조업',
  '욕탕, 마사지 및 기타 신체 관리 서비스업',
  '욕탕업',
  '용기 세척, 포장 및 충전기 제조업',
  '용달 화물 자동차 운송업',
  '우편 및 통신 행정',
  '운동 및 경기용구 제조업',
  '운동 및 경기용품 도매업',
  '운동 및 경기용품 소매업',
  '운동용품 및 자전거 소매업',
  '운송장비 조립용 플라스틱제품 제조업',
  '운송장비용 가스 충전업',
  '운송장비용 연료 소매업',
  '운송장비용 조명장치 제조업',
  '운송장비용 주유소 운영업',
  '운전학원',
  '원목 및 건축관련 목제품 도매업',
  '원양 어업',
  '원유 및 천연가스 채굴업',
  '원유 정제처리업',
  '원자력 발전업',
  '위생용 및 산업용 도자기 제조업',
  '위생용 원지 제조업',
  '위생용 종이제품 제조업',
  '위성 및 기타 방송업',
  '위험 물품 보관업',
  '유기 발광 표시장치 제조업',
  '유기질 비료 및 상토 제조업',
  '유리 및 창호 공사업',
  '유리 및 창호 도매업',
  '유사 의료업',
  '유선 방송업',
  '유선 온라인 게임 소프트웨어 개발 및 공급업',
  '유선 통신업',
  '유선 통신장비 제조업',
  '유선, 위성 및 기타 방송업',
  '유아 교육기관',
  '유아용 의류 도매업',
  '유아용 의류 소매업',
  '유아용 의복 제조업',
  '유압 기기 제조업',
  '유원지 및 테마파크 운영업',
  '유인 항공기, 항공 우주선 및 보조장치 제조업',
  '육류 가공 및 저장 처리업',
  '육류 가공식품 도매업',
  '육류 기타 가공 및 저장 처리업(가금류 제외)',
  '육류 도매업',
  '육류 도축업(가금류 제외)',
  '육류 소매업',
  '육류 포장육 및 냉동육 가공업(가금류 제외)',
  '육림업',
  '육상 금속 골조 구조재 제조업',
  '육상 운송 지원 서비스업',
  '육우 사육업',
  '육지 동물 및 애완 동물 도매업',
  '윤활유 및 그리스 제조업',
  '음ㆍ식료품 및 담배 가공기계 제조업',
  '음ㆍ식료품 및 담배 중개업',
  '음ㆍ식료품 위주 종합 소매업',
  '음료 및 담배 도매업',
  '음료 및 담배 소매업',
  '음료 소매업',
  '음료용 및 향신용 작물 재배업',
  '음반 및 비디오물 도매업',
  '음반 및 비디오물 소매업',
  '음반 및 비디오물 임대업',
  '음반 및 비디오물, 악기, 오락 및 경기용품 도매업',
  '음악 및 기타 오디오물 출판업',
  '음악학원',
  '응용 소프트웨어 개발 및 공급업',
  '의료 기기 도매업',
  '의료용 가구 제조업',
  '의료용 기구 소매업',
  '의료용품 도매업',
  '의료용품 및 기타 의약 관련제품 제조업',
  '의류 임대업',
  '의복 및 기타 가정용 직물제품 수리업',
  '의복 소매업',
  '의복 액세서리 및 모조 장신구 도매업',
  '의복 액세서리 및 모조 장신구 소매업',
  '의약용 화합물 및 항생물질 제조업',
  '의약품 도매업',
  '의약품 및 의료용품 소매업',
  '의약품, 의료용 기구, 화장품 및 방향제 소매업',
  '의약품, 의료용품 및 화장품 도매업',
  '의원',
  '의학 및 약학 연구개발업',
  '이동 음식점업',
  '이동 전화기 제조업',
  '이용 및 미용업',
  '이용업',
  '인력 공급업',
  '인문 및 사회과학 연구개발업',
  '인물 사진 및 행사용 영상 촬영업',
  '인삼식품 제조업',
  '인쇄 및 제책용 기계 제조업',
  '인쇄 잉크 및 회화용 물감 제조업',
  '인쇄관련 산업',
  '인쇄업',
  '인쇄용 및 필기용 원지 제조업',
  '인쇄회로기판 및 전자부품 실장기판 제조업',
  '인쇄회로기판용 적층판 제조업',
  '인테리어 디자인업',
  '인형 및 장난감 제조업',
  '인형, 장난감 및 오락용품 제조업',
  '일반 건축자재 도매업',
  '일반 고등학교',
  '일반 공공 행정',
  '일반 교과학원',
  '일반 교습학원',
  '일반 기계류 수리업',
  '일반 및 생활 숙박시설 운영업',
  '일반 서적 출판업',
  '일반 영화 및 비디오물 제작업',
  '일반 유흥 주점업',
  '일반 저울 제조업',
  '일반 전기 공사업',
  '일반 제재업',
  '일반 중등 교육기관',
  '일반 창고업',
  '일반 철물 제조업',
  '일반 통신 공사업',
  '일반 화물 자동차 운송업',
  '일반병원',
  '일반용 도료 및 관련제품 제조업',
  '일반용 전기 조명장치 제조업',
  '일반은행',
  '일반의원',
  '일식 음식점업',
  '일차전지 및 축전지 제조업',
  '일차전지 제조업',
  '임산물 채취업',
  '임시 및 일용 인력 공급업',
  '임업 관련 서비스업',
  '임업용 종묘 생산업',
  '입법기관',
  '잉크, 페인트, 코팅제 및 유사제품 제조업',
  '자가 소비를 위한 가사 생산 활동',
  '자가 소비를 위한 가사 서비스 활동',
  '자동 판매기 운영업',
  '자동차 구조 및 장치 변경업',
  '자동차 내장용 신품 전기ㆍ전자ㆍ정밀기기 판매업',
  '자동차 세차업',
  '자동차 수리 및 세차업',
  '자동차 신품 부품 및 내장품 판매업',
  '자동차 신품 타이어 및 튜브 판매업',
  '자동차 신품 판매업',
  '자동차 엔진용 신품 부품 제조업',
  '자동차 임대업',
  '자동차 재제조 부품 제조업',
  '자동차 전문 수리업',
  '자동차 제조업',
  '자동차 종합 수리업',
  '자동차 중고 부품 및 내장품 판매업',
  '자동차 차체 및 트레일러 제조업',
  '자동차 차체용 신품 부품 제조업',
  '자동차용 금속 압형제품 제조업',
  '자동차용 기타 신품 부품 제조업',
  '자동차용 신품 동력 전달장치 및 전기장치 제조업',
  '자동차용 신품 동력 전달장치 제조업',
  '자동차용 신품 의자 제조업',
  '자동차용 신품 전기장치 제조업',
  '자동차용 신품 제동장치 제조업',
  '자동차용 신품 조향장치 및 현가장치 제조업',
  '자동차용 엔진 제조업',
  '자동차용 전용 신품 부품 판매업',
  '자료 처리, 호스팅 및 관련 서비스업',
  '자료 처리업',
  '자수제품 및 자수용 재료 제조업',
  '자연공원 운영업',
  '자연과학 및 공학 융합 연구개발업',
  '자연과학 연구개발업',
  '자영 예술가',
  '자전거 및 기타 운송장비 도매업',
  '자전거 및 기타 운송장비 소매업',
  '자전거 및 환자용 차량 제조업',
  '작물재배 관련 서비스업',
  '작물재배 및 축산 복합농업',
  '작물재배 지원 서비스업',
  '잡지 및 정기 간행물 발행업',
  '장난감 및 취미, 오락용품 도매업',
  '장례식장 및 관련 서비스업',
  '장례식장 및 장의관련 서비스업',
  '장류 제조업',
  '장식용 목제품 제조업',
  '재보험업',
  '재생 섬유 제조업',
  '재생용 재료 및 기타 상품 전문 도매업',
  '재생용 재료 수집 및 판매업',
  '재정 및 경제정책 행정',
  '적층, 합성 및 특수 표면처리 종이 제조업',
  '전구 및 램프 제조업',
  '전구, 램프 및 조명장치 도매업',
  '전기 경보 및 신호장치 제조업',
  '전기 공급 및 제어장치 제조업',
  '전기 공사업',
  '전기 판매업',
  '전기ㆍ전자 및 정밀 기기 수리업',
  '전기ㆍ전자공학 연구개발업',
  '전기식 진단 및 요법 기기 제조업',
  '전기용 기계ㆍ장비 및 관련 기자재 도매업',
  '전기용 탄소제품 및 절연제품 제조업',
  '전기용품 및 조명장치 소매업',
  '전기회로 개폐, 보호 장치 제조업',
  '전기회로 접속장치 제조업',
  '전동기 및 발전기 제조업',
  '전동기, 발전기 및 전기 변환장치 제조업',
  '전문 디자인업',
  '전문가 단체',
  '전문대학',
  '전분제품 및 당류 제조업',
  '전세버스 운송업',
  '전시 및 광고용 조명장치 제조업',
  '전시, 컨벤션 및 행사 대행업',
  '전시용 모형 제조업',
  '전자 감지장치 제조업',
  '전자 게임장 운영업',
  '전자 부품 실장기판 제조업',
  '전자 악기 제조업',
  '전자 응용 절삭기계 제조업',
  '전자 저항기 제조업',
  '전자 축전기 제조업',
  '전자기 측정, 시험 및 분석 기구 제조업',
  '전자상거래 소매 중개업',
  '전자상거래 소매업',
  '전자집적회로 제조업',
  '전자카드 제조업',
  '전자코일, 변성기 및 기타 전자 유도자 제조업',
  '전지 및 케이블 도매업',
  '전투용 차량 제조업',
  '절삭 가공 및 유사 처리업',
  '절연 코드세트 및 기타 도체 제조업',
  '절연선 및 케이블 제조업',
  '점술 및 유사 서비스업',
  '점토 벽돌, 블록 및 유사 비내화 요업제품 제조업',
  '접착제 및 젤라틴 제조업',
  '정기 광고 간행물 발행업',
  '정밀 기기 및 과학 기기 도매업',
  '정부기관 일반 보조 행정',
  '정신 질환, 정신 지체 및 약물 중독자 거주 복지시설 운영업',
  '정치 단체',
  '정형 내화 요업제품 제조업',
  '정형 외과용 및 신체 보정용 기기 제조업',
  '젖소 사육업',
  '제강업',
  '제과점업',
  '제도업',
  '제재 및 목재 가공업',
  '제조업 및 유사 산업용 건물 건설업',
  '제조업 회사본부',
  '제책업',
  '제철, 제강 및 합금철 제조업',
  '제철업',
  '제판 및 조판업',
  '제품 디자인업',
  '조경 건설업',
  '조경관리 및 유지 서비스업',
  '조리 반찬류 소매업',
  '조명장치 제조업',
  '조미료 도매업',
  '조미료 및 식품 첨가물 제조업',
  '조적 및 석공사업',
  '종교 단체',
  '종이 및 판지 제조업',
  '종이 원지, 판지, 종이상자 도매업',
  '종이 포대 및 가방 제조업',
  '종이 포대, 판지 상자 및 종이 용기 제조업',
  '종자 및 묘목 도매업',
  '종자 및 묘목 생산업',
  '종합 스포츠시설 운영업',
  '종합병원',
  '종합복지관 운영업',
  '주거용 건물 개발 및 공급업',
  '주거용 건물 건설업',
  '주거용 건물 임대업',
  '주거용 부동산 관리업',
  '주류 도매업',
  '주방용 및 음식점용 목재 가구 제조업',
  '주방용 전기 기기 제조업',
  '주방용품 및 가정용 유리, 요업제품 소매업',
  '주점업',
  '주정 제조업',
  '주차장 운영업',
  '주철관 제조업',
  '주한 외국 공관',
  '주형 및 금형 제조업',
  '중고 가구 소매업',
  '중고 가전제품 및 통신장비 소매업',
  '중고 상품 소매업',
  '중고 자동차 판매업',
  '중식 음식점업',
  '중앙 최고 집행기관',
  '중앙은행',
  '중학교',
  '증권 및 선물 중개업',
  '증권 발행, 관리, 보관 및 거래 지원 서비스업',
  '증권 중개업',
  '증기, 냉ㆍ온수 및 공기 조절 공급업',
  '증류기, 열 교환기 및 가스 발생기 제조업',
  '증류주 및 합성주 제조업',
  '지도 제작업',
  '지반조성 건설업',
  '지방행정 집행기관',
  '지붕, 내ㆍ외벽 축조 관련 전문공사업',
  '지상파 방송업',
  '지정 외 폐기물 수집, 운반업',
  '지정 외 폐기물 처리업',
  '지정 폐기물 수집, 운반업',
  '지정 폐기물 처리업',
  '지주회사',
  '지질 조사 및 탐사업',
  '직물 도매업',
  '직물 직조업',
  '직물, 편조 원단 및 의복류 염색 가공업',
  '직물제품 제조업',
  '직물포대 제조업',
  '직업 재활원 운영업',
  '직원 훈련기관',
  '질소 화합물, 질소ㆍ인산 및 칼리질 화학비료 제조업',
  '차류 가공업',
  '차체 및 특장차 제조업',
  '채소, 과실 및 뿌리작물 소매업',
  '채소, 화훼 및 과실작물 시설 재배업',
  '채소, 화훼작물 및 종묘 재배업',
  '채소류, 서류 및 향신작물류 도매업',
  '채소작물 재배업',
  '천막, 텐트 및 유사 제품 제조업',
  '천연 및 혼합 조제 조미료 제조업',
  '천연수지 및 나무 화학 물질 제조업',
  '천일염 생산 및 암염 채취업',
  '천주교 단체',
  '철 광업',
  '철강 압연, 압출 및 연신제품 제조업',
  '철강 주조업',
  '철강관 제조업',
  '철강선 제조업',
  '철골 및 관련 구조물 공사업',
  '철도 궤도 전문공사업',
  '철도 여객 운송업',
  '철도 운송 지원 서비스업',
  '철도 운송업',
  '철도 차량 부품 및 관련 장치물 제조업',
  '철도 화물 운송업',
  '철도장비 제조업',
  '철물 및 난방용구 소매업',
  '철물, 공구, 창호 및 건설자재 소매업',
  '철물, 금속 파스너 및 수공구 도매업',
  '청소년 수련시설 운영업',
  '체력 단련시설 운영업',
  '체육 공원 및 유사 공원 운영업',
  '체인화 편의점',
  '체조, 육상 및 체력 단련용 장비 제조업',
  '체형 등 기타 신체 관리 서비스업',
  '초등학교',
  '축산 관련 서비스업',
  '축산 분뇨 처리업',
  '축전지 제조업',
  '출장 및 이동 음식점업',
  '출장 음식 서비스업',
  '측량, 지질 조사 및 지도 제작업',
  '측량업',
  '측정, 시험, 항해, 제어 및 기타 정밀 기기 제조업',
  '치과병원',
  '치과용 기기 제조업',
  '치과의원',
  '치약, 비누 및 기타 세제 제조업',
  '치킨 전문점',
  '침구 및 관련제품 제조업',
  '침대 및 내장 가구 제조업',
  '카펫, 마루덮개 및 유사 제품 제조업',
  '커튼 및 유사 제품 제조업',
  '커튼 및 침구용품 도매업',
  '커피 가공업',
  '커피 및 차류 도매업',
  '커피 전문점',
  '컨베이어 장치 제조업',
  '컴퓨터 게임방 운영업',
  '컴퓨터 모니터 제조업',
  '컴퓨터 및 사무용 기계ㆍ장비 임대업',
  '컴퓨터 및 주변 기기 수리업',
  '컴퓨터 및 주변장치, 소프트웨어 도매업',
  '컴퓨터 및 주변장치, 소프트웨어 및 통신기기 소매업',
  '컴퓨터 및 주변장치, 소프트웨어 소매업',
  '컴퓨터 시스템 통합 자문 및 구축 서비스업',
  '컴퓨터 시스템 통합 자문, 구축 및 관리업',
  '컴퓨터 제조업',
  '컴퓨터 프로그래밍 서비스업',
  '컴퓨터 프린터 제조업',
  '컴퓨터 학원',
  '컴퓨터시설 관리업',
  '코르크 및 조물 제품 제조업',
  '코크스 및 관련제품 제조업',
  '코크스 및 연탄 제조업',
  '콘크리트 관 및 기타 구조용 콘크리트제품 제조업',
  '콘크리트 및 철근 공사업',
  '콘크리트 타일, 기와, 벽돌 및 블록 제조업',
  '콘크리트, 레미콘 및 기타 시멘트, 플라스터 제품 제조업',
  '콜센터 및 텔레마케팅 서비스업',
  '콩나물 재배업',
  '크라프트지 및 상자용 판지 제조업',
  '타이어 및 튜브 제조업',
  '타이어 재생업',
  '타일 및 유사 비내화 요업제품 제조업',
  '탁주 및 약주 제조업',
  '탄소섬유 제조업',
  '탐정 및 조사 서비스업',
  '태권도 및 무술 교육기관',
  '태양력 발전업',
  '택배업',
  '택시 운송업',
  '탭, 밸브 및 유사 장치 제조업',
  '텔레비전 제조업',
  '텔레비전, 비디오 및 기타 영상 기기 제조업',
  '토공사업',
  '토목 시설물 건설업',
  '토양 및 지하수 정화업',
  '톱 및 호환성 공구 제조업',
  '통관 대리 및 관련서비스업',
  '통신 공사업',
  '통신 재판매업',
  '통신 판매업',
  '통신ㆍ방송장비 및 부품 도매업',
  '통신기기 소매업',
  '통신장비 수리업',
  '투자 자문업 및 투자 일임업',
  '트레일러 및 세미 트레일러 제조업',
  '특성화 고등학교',
  '특수 여객 자동차 운송업',
  '특수사 및 코드직물 제조업',
  '특수직물 및 기타 직물 직조업',
  '특수학교',
  '파이프라인 운송업',
  '파일공사 및 축조관련 기초 공사업',
  '판유리 및 판유리 가공품 제조업',
  '판유리 제조업',
  '판지 상자 및 용기 제조업',
  '패션, 섬유류 및 기타 전문 디자인업',
  '펄프 및 종이 가공용 기계 제조업',
  '펄프 제조업',
  '펌프 및 압축기 제조업; 탭, 밸브 및 유사 장치 제조 포함',
  '페인트, 창호 및 기타 건설자재 소매업',
  '편조 원단 제조업',
  '편조 의복 액세서리 제조업',
  '편조의복 제조업',
  '폐수 처리업',
  '포장 공사업',
  '포장 및 충전업',
  '포장용 유리용기 제조업',
  '포장용 플라스틱 성형용기 제조업',
  '포장용 플라스틱제품 제조업',
  '포털 및 기타 인터넷 정보 매개 서비스업',
  '폴리스티렌 발포 성형제품 제조업',
  '표구 처리업',
  '표면 가공목재 및 특정 목적용 제재목 제조업',
  '표면 광택제 및 실내 가향제 제조업',
  '표면처리 및 적층 직물 제조업',
  '표시장치 제조업',
  '프로그램 공급업',
  '플라스터 혼합제품 제조업',
  '플라스틱 물질 및 합성고무 도매업',
  '플라스틱 발포 성형제품 제조업',
  '플라스틱 선, 봉, 관 및 호스 제조업',
  '플라스틱 시트 및 판 제조업',
  '플라스틱 적층, 도포 및 기타 표면처리 제품 제조업',
  '플라스틱 접착처리 제품 제조업',
  '플라스틱 창호 제조업',
  '플라스틱 포대, 봉투 및 유사제품 제조업',
  '플라스틱 필름 제조업',
  '플라스틱 합성피혁 제조업',
  '피복 및 충전 용접봉 제조업',
  '피부 미용업',
  '피자, 햄버거, 샌드위치 및 유사 음식점업',
  '하수 및 폐수 처리업',
  '하수 처리업',
  '한방병원',
  '한복 소매업',
  '한복 제조업',
  '한식 면 요리 전문점',
  '한식 육류 요리 전문점',
  '한식 음식점업',
  '한식 일반 음식점업',
  '한식 해산물 요리 전문점',
  '한의약품 제조업',
  '한의원',
  '합금철 제조업',
  '합성고무 및 플라스틱 물질 제조업',
  '합성고무 제조업',
  '합성섬유 제조업',
  '합성수지 및 기타 플라스틱 물질 제조업',
  '합성수지선 건조업',
  '항공 및 육상 화물 취급업',
  '항공 여객 운송업',
  '항공 운송 지원 서비스업',
  '항공 화물 운송업',
  '항공기, 우주선 및 보조장치 제조업',
  '항공기용 부품 제조업',
  '항공기용 엔진 및 부품 제조업',
  '항공기용 엔진 제조업',
  '항구 및 기타 해상 터미널 운영업',
  '항만 내 여객 운송업',
  '항만, 수로, 댐 및 유사 구조물 건설업',
  '해당사항 없음',
  '해수면 양식 어업',
  '해수면 어업',
  '핵반응기 및 증기보일러 제조업',
  '핸드백 및 지갑 제조업',
  '핸드백, 가방 및 기타 보호용 케이스 제조업',
  '호스팅 및 관련 서비스업',
  '호텔업',
  '혼성 및 재생 플라스틱 소재 물질 제조업',
  '화력 발전업',
  '화물 운송 중개, 대리 및 관련 서비스업',
  '화물 자동차 및 특수 목적용 자동차 제조업',
  '화물 취급업',
  '화물 포장, 검수 및 계량 서비스업',
  '화약 및 불꽃제품 제조업',
  '화장터 운영, 묘지 분양 및 관리업',
  '화장품 및 화장용품 도매업',
  '화장품 제조업',
  '화장품, 비누 및 방향제 소매업',
  '화초 및 식물 소매업',
  '화학 물질 및 화학제품 도매업',
  '화학 살균ㆍ살충제 및 농업용 약제 제조업',
  '화학섬유 방적업',
  '화학섬유 제조업',
  '화학섬유직물 직조업',
  '화학용 및 비료 원료용 광물 광업',
  '화훼류 및 식물 도매업',
  '화훼작물 재배업',
  '환경 관련 엔지니어링 서비스업',
  '환경 정화 및 복원업',
  '환경 행정',
  '환경설비 건설업',
  '환경운동 단체',
  '회계 및 세무관련 서비스업',
  '회사본부',
  '휴양 콘도 운영업',
];
